import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

import { CancelButton, FormButton } from '../../../../../components/Button';
import CustomDropdown from '../../../../../components/DropDown';
import { FormFieldset, Input, Textarea } from '../../../../../components/Form';
import Loader from '../../../../../components/Loader';
import VideoModal from '../../../../../components/VideoModal';
import { formatDate, Roles } from '../../../../../util/constant';
import ScreenRecorder from '../../../ScreenRecorder';
import { priority, status } from '../../__Test__/MockTasksheet';
import { IAddTaskSheet } from '../../Tasksheet.props';
import useAddTaskSheet from './useAddTasksheet';

const AddTaskSheet: React.FC = () => {
  const {
    loading,
    formData,
    tasks,
    handleChange,
    handleSubmit,
    handleCancel,
    setDefaultPriority,
    defaultPriority,
    defaultStatus,
    setDefaultStatus,
    user,
    userId,
    setUserId,
    addOrUpdateTask,
    removeTask,
    editTask,
    editIndex,
    project,
    projectId,
    setProjectId,
    setFormData,
    isVideo,
    setIsVideo,
  } = useAddTaskSheet();
  const { handleSubmit: useFormSubmit } = useForm<IAddTaskSheet>();
  const [showRecorder, setShowRecorder] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [selectedVideoUrl, setSelectedVideoUrl] = useState("");
  const Role = localStorage.getItem("role");
  const subRole = localStorage.getItem("subRole");
  const personalFields = [
    { label: "Description", name: "description", type: "textbox" },
  ] as const;

  const handleVideoClick = (videoUrl: string | undefined) => {
    if (videoUrl) {
      setSelectedVideoUrl(videoUrl);
      setShowVideoModal(true);
    }
  };

  return (
    <div className="flex flex-col items-center w-full h-full pr-8 pl-6 ">
      <div className="bg-white shadow-md rounded-lg pt-6 pb-6 w-full ">
        <div className="border-b-2 w-[100%]">
          <h1 className="text-3xl mb-2 text-fontBlack ml-5">Add TaskSheet</h1>
        </div>
        {loading && <Loader />}
        <div></div>
        <form
          className="space-y-8 p-8 h-[75vh] overflow-y-auto bg-gray-50 shadow-md rounded-lg"
          onSubmit={useFormSubmit(handleSubmit)}
        >
          <FormFieldset>
            <div className="flex justify-center">
              <div className="grid grid-cols-2 w-[45vh] m-4 -mt-4">
                {(Roles.admin === Role ||
                  (Roles.employee && Roles.tl === subRole)) && (
                  <CustomDropdown
                    label="Assigned To:"
                    options={user}
                    defaultOptionId={userId}
                    setDefaultOptionId={setUserId}
                    displayProperty="name"
                    value={userId}
                    style="w-full"
                  />
                )}
                <CustomDropdown
                  label="Project:"
                  options={project}
                  defaultOptionId={projectId}
                  setDefaultOptionId={setProjectId}
                  displayProperty="name"
                  value={projectId}
                  style="w-full"
                />

                <CustomDropdown
                  label="Priority:"
                  options={priority}
                  defaultOptionId={defaultPriority}
                  setDefaultOptionId={setDefaultPriority}
                  displayProperty="name"
                  value={defaultPriority}
                  style="w-full"
                />
                <CustomDropdown
                  label="Status:"
                  options={status}
                  defaultOptionId={defaultStatus}
                  setDefaultOptionId={setDefaultStatus}
                  displayProperty="name"
                  value={defaultStatus}
                  style="w-full"
                />
              </div>
              <div className="grid grid-cols-2 gap-2 ">
                <div>
                  <label className="text-fontBlack text-xs mb-2 flex">
                    Due Date:
                  </label>
                  <input
                    type="date"
                    name="dueDate"
                    className={`appearance-none border h-14 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline border-border`}
                    value={
                      formData.dueDate
                        ? new Date(formData.dueDate).toISOString().split("T")[0]
                        : ""
                    }
                    onChange={(e) => {
                      handleChange(e);
                      setFormData({ ...formData, dueDate: e.target.value });
                    }}
                  />
                  <button
                    type="button"
                    className=" p-1 m-1 bg-blue-500 text-white rounded"
                    onClick={() => {
                      const tomorrow = new Date();
                      tomorrow.setDate(tomorrow.getDate() + 1);
                      setFormData({
                        ...formData,
                        dueDate: tomorrow.toISOString().split("T")[0],
                      });
                    }}
                  >
                    Tomorrow
                  </button>
                </div>
                {personalFields.map((field) => (
                  <Textarea
                    key={field.name}
                    name={field.name}
                    label={field.label}
                    type={field.type}
                    value={formData[field.name]}
                    onChange={handleChange}
                  />
                ))}
              </div>
            </div>
            <div className="flex gap-2">
              <input
                type="checkbox"
                checked={formData.isUserVideoReq}
                className="w-5"
                onChange={(e) =>
                  setFormData({ ...formData, isUserVideoReq: e.target.checked })
                }
              />
              <p>User video is required</p>
            </div>
            <div className="flex gap-4">
              <button
                type="button"
                onClick={() => setShowRecorder(true)}
                className="py-3 px-6 w-48 h-14 bg-purple-600 text-white rounded-lg shadow-md hover:bg-purple-700 transition"
              >
                Record Screen
              </button>
              <button
                type="button"
                onClick={addOrUpdateTask}
                className="py-3 px-6 w-48 h-14 bg-green-600 text-white rounded-lg shadow-md hover:bg-green-700 transition"
              >
                {editIndex !== null ? "Update Task" : "Add Task"}
              </button>
            </div>
          </FormFieldset>
          <div className="-mt-4">
            <h2 className="text-xl font-semibold mb-4">
              Current Tasks ({tasks.length}/10)
            </h2>
            <table className="table-auto w-full border-collapse bg-white shadow-md rounded-lg overflow-hidden">
              <thead>
                <tr className="bg-gray-100 text-gray-700">
                  <th className="border-b p-4">Project</th>
                  <th className="border-b p-4">Description</th>
                  <th className="border-b p-4">Due Date</th>
                  <th className="border-b p-4">Priority</th>
                  <th className="border-b p-4">Status</th>
                  <th className="border-b p-4">Video</th>
                  <th className="border-b p-4">Actions</th>
                </tr>
              </thead>
              <tbody>
                {tasks.map((task, index) => (
                  <tr key={index} className="odd:bg-gray-50 even:bg-white">
                    <td className="border p-4 text-center">
                      {(() => {
                        const data = project?.find(
                          (pr) => pr.id === task.projectId
                        );
                        return data?.name || "N/A";
                      })()}
                    </td>
                    <td className="border p-4 text-center">
                      {task.description}
                    </td>
                    <td className="border p-4 text-center">
                      {formatDate(task.dueDate)}
                    </td>
                    <td className="border p-4 text-center">{task.priority}</td>
                    <td className="border p-4 text-center">{task.status}</td>
                    <td className="border p-4 text-center">
                      {task.videoUrl ? (
                        <button
                          onClick={() => handleVideoClick(task.videoUrl)}
                          className="text-blue-600 hover:text-blue-800 underline"
                          type="button"
                        >
                          View Video
                        </button>
                      ) : (
                        "No video"
                      )}
                    </td>
                    <td className="border p-4 flex justify-center gap-2">
                      <button
                        onClick={() => editTask(index)}
                        className="text-blue-600 hover:text-blue-700 transition"
                        type="button"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => removeTask(index)}
                        className="text-red-600 hover:text-red-700 transition"
                        type="button"
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="flex justify-center gap-4 mt-8">
            <CancelButton
              onClick={handleCancel}
              className="py-3 px-6 w-48 bg-gray-200 text-gray-800 rounded-lg shadow-md hover:bg-gray-300 transition"
              children="Cancel"
              type={undefined}
            />
            <FormButton
              className="py-3 px-6 w-48 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700 transition"
              children="Submit"
              type="submit"
            />
          </div>
        </form>
      </div>

      {/* Screen Recorder Modal */}
      {showRecorder && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-[90%] max-w-4xl">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-semibold">Screen Recorder</h2>
              <button
                onClick={() => setShowRecorder(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>
            <ScreenRecorder
              onSave={(videoUrl) => {
                setFormData({ ...formData, videoUrl });
                setShowRecorder(false);
              }}
            />
          </div>
        </div>
      )}

      {/* Video Modal */}
      <VideoModal
        isOpen={showVideoModal}
        onClose={() => setShowVideoModal(false)}
        videoUrl={selectedVideoUrl}
        title="Task Video"
      />
    </div>
  );
};

export default AddTaskSheet;
